import { render, staticRenderFns } from "./BrandManageLogo.vue?vue&type=template&id=2aee483e&"
import script from "./BrandManageLogo.vue?vue&type=script&lang=ts&"
export * from "./BrandManageLogo.vue?vue&type=script&lang=ts&"
import style0 from "./BrandManageLogo.vue?vue&type=style&index=0&id=2aee483e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports